// Mobile menu toggle
function toggleMenu() {
  const nav = document.getElementById('mainNav');
  if (nav) {
    nav.classList.toggle('active');
  }
}

// Add to cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.getElementById('cart-count');
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Handle add to cart forms
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success message
        alert('Product added to cart!');
        updateCartCount();
      })
      .catch(error => {
        console.error('Error:', error);
        alert('There was an error adding the product to cart.');
      });
    });
  });

  // Initial cart count update
  updateCartCount();

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Product page image gallery (if needed)
document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.product-thumbnails img');
  const mainImage = document.querySelector('.product-main-image');
  
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      if (mainImage) {
        mainImage.src = this.src.replace('_200x200', '_800x800');
      }
    });
  });
});
